import React from 'react';
import Draggable from 'react-draggable';
import { Resizable } from 're-resizable';
import '../desktop-components-css/Window.css';

class ApplicationWindow extends React.Component {
  constructor(props) {
    super(props);
    let componentSize = this.props.appObject.size;
    let componentWidth = componentSize[0];
    let componentHeight = componentSize[1];
    let windowTitle = this.props.appObject.name;
    if(this.props.filename !== null) {
      windowTitle = windowTitle + " - " + this.props.filename;
    }
    this.state = {
      windowTitle: windowTitle,
      minSize: {
        width: componentWidth,
        height: componentHeight,
      },
      savedSize: {
        width: "",
        height: "",
      },
      currentSize: {
        width: componentWidth,
        height: componentHeight,
      },
      isMaximized: false,
      savedPosition: {
        x: 0,
        y: 0
      },
      currentPosition: {
        x: this.getRandomNumber(20, this.props.desktopSize.width - componentWidth - 40),
        y: this.getRandomNumber(10, this.props.desktopSize.height - componentHeight - 100),
      }
    };
    this.changeWindowTitle = this.changeWindowTitle.bind(this);
    this.changeMaximizeSize = this.changeMaximizeSize.bind(this);
    this.appMaximizeHandler = this.appMaximizeHandler.bind(this);
    this.maximizedDragHandler = this.maximizedDragHandler.bind(this);
    this.changeCurrentPosition = this.changeCurrentPosition.bind(this);
  }

  changeWindowTitle(newTitle) {
    this.setState({
      windowTitle: newTitle,
    });
  }

  getRandomNumber(min, max) {
    let rand = min + (Math.random() * (max - min));
    rand = Math.floor(rand);
    return rand;
  }

  changeMaximizeSize() {
    this.setState({
      currentSize: {
        width: this.props.desktopSize.width - 8,
        height: this.props.desktopSize.height - 75
      }
    });
  }

  appMaximizeHandler(event, appIndex) {
    if(this.state.isMaximized === true) {
      window.removeEventListener('resize', this.changeMaximizeSize);
      this.setState({
        currentPosition: this.state.savedPosition,
        currentSize: this.state.savedSize,
        isMaximized: false
      });
    }
    else {
      window.addEventListener('resize', this.changeMaximizeSize);
      this.setState({
        savedPosition: this.state.currentPosition,
        savedSize: this.state.currentSize
      });
      this.setState({
        currentPosition: {x: 0, y: 0},
        currentSize: {
          width: this.props.desktopSize.width - 8,
          height: this.props.desktopSize.height - 75
        },
        isMaximized: true
      })
    }
  }

  maximizedDragHandler = (event, ui) => {
    if(this.state.isMaximized === true) {
      event.stopPropagation();
      this.setState({
        currentPosition: this.state.savedPosition,
        currentSize: this.state.savedSize,
        isMaximized: false,
      });
    }
  }

  changeCurrentPosition = (event, position) => {
    event.stopPropagation();
    const {x, y} = position;
    this.setState({
      currentPosition: {x, y}
    });
  }

  render() {
    return (
      <Draggable
          handle="#topBarInfo"
          bounds="#screen"
          onStart={this.maximizedDragHandler}
          onStop={this.changeCurrentPosition}
          position={this.state.currentPosition}
          defaultPosition={this.state.currentPosition}>
        <div id="appWindow"
            data-testid = "main-window"
            onClick = {() => this.props.appFocusHandler(this.props.arrayIndex)}
            style = {{
              zIndex: this.props.zIndex,
              width: this.state.currentSize.width + 5 + "px"
            }}>
          <div id="handle" data-testid = "top-window">
            <AppTopbar
              icon = {this.props.appObject.smallIcon}
              windowTitle = {this.state.windowTitle}
              appIndex = {this.props.arrayIndex}
              currentWidth={this.state.currentSize.width}
              appMinimizeHandler = {this.props.appMinimizeHandler}
              appMaximizeHandler = {this.appMaximizeHandler}
              appExitHandler = {this.props.appExitHandler}
            />
          </div>
          <Resizable
            minWidth={this.state.minSize.width}
            minHeight={this.state.minSize.height}
            size={this.state.currentSize}
            onResizeStop={(e, direction, ref, d) => {
              this.setState({
                currentSize: {
                  width: this.state.currentSize.width + d.width,
                  height: this.state.currentSize.height + d.height,
                },
              });
            }}>
            <div id="appInside"
              data-testid = "inside-window"
              style = {{
                width: this.state.currentSize.width + 5 + "px",
                height: this.state.currentSize.height + "px"
              }}>
                <this.props.appObject.component
                  appLauncherHandler = {this.props.appLauncherHandler}
                  filename = {this.props.filename}
                  propMethod = {this.props.propMethod}
                  width = {this.state.currentSize.width + 5}
                  height = {this.state.currentSize.height}
                />
            </div>
          </Resizable>
        </div>
      </Draggable>
    );
  }
}

function AppTopbar(props) {
  return (
    <div id="topBar"
      style = {{
        width: props.currentWidth - 5 + "px",
      }}>
      <div id="topBarInfo" data-testid = "topbar-info">
        <img src={props.icon} draggable="false" alt={props.windowTitle}/>
        <p>{props.windowTitle}</p>
      </div>
      <div id="topBarButtons" data-testid = "topbar-buttons">
        <button onClick = {e => props.appMinimizeHandler(e, props.appIndex)}>-</button>
        <button onClick = {e => props.appMaximizeHandler(e, props.appIndex)}>o</button>
        <button onClick = {e => props.appExitHandler(e, props.appIndex)}>X</button>
      </div>
    </div>
  );
}

export default ApplicationWindow;
